import * as appVer from "./version";

(function () {
  "use strict";

  console.log("chat-widget v" + appVer.VERSION.version);

  var logging = true;
  var widget_debug = false;

  var context = "";
  var configJSON;

  var isAvailable = false;
  var isChatBtnEnabled = false;
  var loopEnabled = true;
  var loopId;

  function log(text, ...obj) {
    if (logging) console.log(text, ...obj);
  }

  function getJSON(url, callback) {
    var xobj = new XMLHttpRequest();
    xobj.overrideMimeType("application/json");
    xobj.open("GET", url, true);
    xobj.onreadystatechange = function () {
      if (xobj.readyState === 4 && xobj.status == "200") {
        callback(xobj.responseText);
      }
    };
    xobj.send(null);
  }

  function wait(time) {
    return new Promise(function (resolve) {
      setTimeout(resolve, time);
    });
  }

  function internalStatisticPromise(url) {
    return new Promise(function (resolve, reject) {
      // log('getInternalStatisticPromise.call');
      var xhr = new XMLHttpRequest();
      // xhr.responseType = 'json'; // nefunguje v Edge a IE
      xhr.open("POST", url, true);
      xhr.timeout = 1000;
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.onreadystatechange = function (e) {
        // log('getInternalStatistic.resp.e', e);
        // log('getInternalStatistic.resp.xobj', xhr);
        // log('getInternalStatisticPromise.resp.xhr', xhr.status, xhr.response);
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            var respJson = JSON.parse(xhr.responseText);
            resolve(respJson);
          } else {
            var r = {
              status: xhr.status,
              // body: JSON.parse(xhr.responseText),
              body: xhr.responseText,
            };
            // log('getInternalStatisticPromise.resp.r', r);
            reject(r);
          }
        }
      };
      xhr.send();
    });
  }

  function getChatButton($) {
    // return $("#custChatButton");
    return $(".cx-widget .cx-webchat-chat-button");
  }
  function getChatButtonLabel($) {
    return $(".cx-chat-button-label");
  }

  function execCommand(b, cmd) {
    return new Promise(function (resolve, reject) {
      b.command(cmd, {})
        .done((resp) => {
          console.log("execCommand.success", cmd, resp);
          resolve(resp);
        })
        .fail((err) => {
          // console.error("execCommand.err", cmd, err);
          reject(err);
        });
    });
  }

  function setChatButtonVisiblePromise(b, visible) {
    var cmd = visible ? "WebChat.showChatButton" : "WebChat.hideChatButton";
    return execCommand(b, cmd);
  }

  function setChatButtonVisible(b, visible) {
    var cmd = visible ? "WebChat.showChatButton" : "WebChat.hideChatButton";
    b.command(cmd, {})
      .done(() => log("setChatButtonVisible.success", cmd))
      .fail((err) => {
        if (!err.includes("Ignoring command.")) {
          console.error("setChatButtonVisible.err", cmd, err);
        }
      });
  }

  function setChatButtonVisibleDelayed(b, visible, delay) {
    setTimeout(() => {
      setChatButtonVisiblePromise(b, visible);
    }, delay);
  }

  function handleChatButton($, b, configJSON) {
    var btn = getChatButton($);
    if (btn.length === 0) {
      return false;
    }
    var btnLabel = getChatButtonLabel($);
    if (isAvailable) {
      btn.removeClass("alc-not-available");
      btn.addClass("alc-available");
      btnLabel.html(configJSON.chatButtonOnline);
      btn.off();
      btn.click(function (e) {
        log("chatButton.click");
        b.command("WebChat.open", {
          form: {
            autoSubmit: true,
          },
        })
          .done(function (e) {
            log("WebChat.open.success", e);
          })
          .fail(function (e) {
            log("WebChat.open.err", e);
          });
        return false;
      });
    } else {
      btn.removeClass("alc-available");
      btn.addClass("alc-not-available");
      btnLabel.html(configJSON.chatButtonOffline);
      btn.off();
      btn.click(function (e) {
        // log('click', e);
        window.open(configJSON.notAvailableUrl, "_self");
        return false;
      });
    }
    return true;
  }

  function startStat1Loop($, b, configJSON) {
    loopEnabled = true;
    checkStat1Loop($, b, configJSON);
  }

  function processStats($, b, configJSON) {
    Promise.all([getStatValue(configJSON.statisticUrl1), getStat2Value(configJSON)]).then(function ([value1, value2]) {
      console.log("checkStat1Loop.val1", value1, "val2", value2);
      // value2 = 0; // DEBUG
      if (value2 === 0) {
        isChatBtnEnabled = false;
        setChatButtonVisible(b, false);
      } else {
        isChatBtnEnabled = true;
        setChatButtonVisible(b, true);
        isAvailable = value1 > 0;
        handleChatButton($, b, configJSON);
      }
      checkStat1Loop($, b, configJSON);
    });
  }

  function checkStat1Loop($, b, configJSON) {
    if (!loopEnabled || configJSON.statisticTimeout === 0) {
      return;
    }
    clearTimeout(loopId);
    loopId = setTimeout(function () {
      processStats($, b, configJSON);
    }, configJSON.statisticTimeout);
  }

  function getStatValue(url) {
    if (!configJSON.statistic1Enabled) {
      return Promise.resolve(configJSON.statistic1Default);
    }
    return internalStatisticPromise(url).then(
      (resp) => resp.value,
      (err) => configJSON.statistic1Default
    );
  }

  function getStat2Value(configJSON) {
    if (!configJSON.statistic2Enabled) {
      return Promise.resolve(configJSON.statistic2Default);
    }
    return internalStatisticPromise(configJSON.statisticUrl2).then(
      (resp) => resp.value,
      (err) => configJSON.statistic2Default
    );
  }

  function getStat1AndHandle($, b, configJSON) {
    return getStatValue(configJSON.statisticUrl1).then(
      function (value) {
        // log('getInternalStatisticPromise.resp.success', resp);
        isAvailable = value > 0;
        handleChatButton($, b, configJSON);
      },
      function (err) {
        // log('getInternalStatisticPromise.resp.error', err);
        isAvailable = false;
        handleChatButton($, b, configJSON);
      }
    );
  }

  //load config
  (function init() {
    var setupWidget = function () {
      if (!window._genesys) window._genesys = {};
      if (!window._gt) window._gt = [];

      window._genesys.widgets = {
        onReady: function (CXBus) {
          console.log("widgets.onReady: " + window._genesys.widgets.common.data("version"));
          CXBus.command("App.info");
        },
        main: {
          debug: widget_debug,
          // theme: "light",
          // theme: "dark",
          // theme: "union",
          theme: configJSON.theme,
          themes: {
            union: "cx-theme-union",
          },
          lang: "sk",
          // lang: "en",
          i18n: context + "resources/widgets-sk.i18n.json",
          timeFormat: 24,
          // customStylesheetID: "custom-genesys-widgets-styles",
          //   downloadGoogleFont: false,
        },
        webchat: {
          apikey: "",
          dataURL: configJSON.GMSChatURL,
          userData: configJSON.userData,
          emojis: false,
          uploadsEnabled: false,
          timeFormat: 24,
          chatButton: {
            enabled: true,
          },
          form: {
            wrapper: "<table></table>",
            inputs: [
              {
                id: "cx_webchat_form_nickname",
                type: "hidden",
                name: "nickname",
                value: configJSON.nickname,
                maxlength: "100",
                placeholder: "@i18n:webchat.ChatFormPlaceholderNickname",
                label: "@i18n:webchat.ChatFormNickname",
              },
              {
                id: "cx_webchat_form_subject",
                type: "hidden",
                name: "subject",
                value: "union.sk",
                maxlength: "100",
                placeholder: "@i18n:webchat.ChatFormPlaceholderSubject",
                label: "@i18n:webchat.ChatFormSubject",
              },
            ],
          },
        },
      };

      if (!window._genesys.widgets.extensions) {
        window._genesys.widgets.extensions = {};
      }

      window._genesys.widgets.extensions.alcExt = function ($, CXBus, CXCommon) {
        var b = CXBus.registerPlugin("alcExt");

        b.subscribe("App.ready", function (e) {
          console.log("ext.App.ready");
        });

        b.subscribe("WebChat.ready", function (e) {
          console.log("ext.WebChat.ready", e);
          // var btn = $(".cx-widget .cx-webchat-chat-button");
          // console.log("ext.WebChat.ready.chatBtn", btn);

          isAvailable = false;

          getStat2Value(configJSON).then(function (val2) {
            console.log("ext.WebChat.ready.value2", val2);
            if (val2 === 0) {
              isChatBtnEnabled = false;
              setChatButtonVisible(b, false);
              // setChatButtonVisibleDelayed(b, false, 500);
            } else {
              isChatBtnEnabled = true;
              if (configJSON.statisticTimeout === 0) {
                isAvailable = true;
              } else {
                getStat1AndHandle($, b, configJSON);
              }
            }
            startStat1Loop($, b, configJSON);
          });

          // setupChatButton($, b);
          // hideButtons(b);
          // getStatAndHandle($, b); // zisti stav hned ako je to mozne
          // loopEnabled = true;
          // checkAgentLoop($, b);
        });

        b.subscribe("WebChat.chatButtonDisplayed", function (e) {
          console.log("ext.WebChat.chatButtonDisplayed", e);
          var btn = $(".cx-widget .cx-webchat-chat-button");
          console.log("ext.WebChat.chatButtonDisplayed.chatBtn", btn);
          if (!isChatBtnEnabled) {
            setChatButtonVisibleDelayed(b, false, 500);
            return;
          }
          getStat1AndHandle($, b, configJSON);
        });

        b.subscribe("WebChat.opened", function (e) {
          log("ext.WebChat.opened", e);
          loopEnabled = false;
          clearTimeout(loopId);
        });
        b.subscribe("WebChat.closed", function (e) {
          log("ext.WebChat.closed", e);
          startStat1Loop($, b, configJSON);
        });
      };

      // widget_version = '9.0';
      // const widget_version = "9.0.006";
      // const widget_version = "9.0.007"; // zakaznik ma avatara
      // const widget_version = "9.0.008";
      // const widget_version = "9.0.017";

      (function (o) {
        var f = function () {
            var d = o.location;
            o.aTags = o.aTags || [];
            for (var i = 0; i < o.aTags.length; i++) {
              var oTag = o.aTags[i];
              var fs = d.getElementsByTagName(oTag.type)[0],
                e;
              if (d.getElementById(oTag.id)) return;
              e = d.createElement(oTag.type);
              e.id = oTag.id;
              if (oTag.type == "script") {
                e.src = oTag.path;
              } else {
                e.type = "text/css";
                e.rel = "stylesheet";
                e.href = oTag.path;
              }
              if (fs) {
                fs.parentNode.insertBefore(e, fs);
              } else {
                d.head.appendChild(e);
              }
            }
          },
          ol = window.onload;
        if (o.onload) {
          if (typeof window.onload != "function") {
            window.onload = f;
          } else {
            window.onload = function () {
              ol();
              f();
            };
          }
        } else {
          f();
        }
      })({
        location: document,
        onload: false,
        aTags: [
          {
            type: "script",
            id: "genesys-cx-widget-script",
            path: context + "resources/widgets.min.js",
            // path: `https://apps.mypurecloud.ie/widgets/${widget_version}/widgets.min.js`,
          },
          {
            type: "link",
            id: "genesys-cx-widget-styles",
            path: context + "resources/widgets.min.css",
            // path: `https://apps.mypurecloud.ie/widgets/${widget_version}/widgets.min.css`,
          },
          {
            type: "link",
            id: "custom-genesys-widgets-styles",
            path: context + "resources/theme-union.css",
          },
        ],
      });
    };

    getJSON(context + "widget-config.json", function (response) {
      configJSON = JSON.parse(response);
      setupWidget();
    });
  })();
})();
